import { FilterSection } from "@flights/search-ui";
import React from "react";
import { useDurationFilterController } from "./useDurationFilter.controller.js";
import { InputSlider } from "@bookingcom/bui-react";
import styles from "./DurationFilter.module.css";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
export const DurationFilter = () => {
    const { isFilterAvailable, title, showReset, resetLabel, onClickReset, min, max, value, ariaLabel, label, renderTooltipValue, renderValue, onChange, onChangeCommit, keyForRemount } = useDurationFilterController();
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    const i18n = useI18n();
    if (!isFilterAvailable)
        return null;
    return (React.createElement(FilterSection, { attributes: { "data-testid": "duration_filter" }, title: {
            text: title,
            tagName: "h3",
            attributes: { id: "duration_filter" },
            variant: trackLayoverPriceAirportFilterWeb() ? "strong_2" : "emphasized_1"
        }, reset: showReset
            ? {
                text: resetLabel,
                onClick: onClickReset,
                attributes: {
                    "data-testid": "search_filter_duration_reset",
                    "aria-label": i18n.trans(t("a11y_flights_filter_reset_duration"))
                }
            }
            : undefined },
        React.createElement("div", { className: styles.inputSliderWrapper },
            React.createElement(InputSlider, { key: keyForRemount, min: min, max: max, value: value, name: "filters-duration", attributes: { "data-testid": "search_filter_duration_slider" }, ariaLabel: ariaLabel, label: label, onChange: ({ value }) => onChange(value), onChangeCommit: ({ value }) => onChangeCommit(value), renderTooltipValue: renderTooltipValue, ariaValuetext: renderTooltipValue, renderValue: (val) => React.createElement("span", { "data-testid": "search_filter_duration_travel_time_label" }, renderValue(val)) }))));
};
